// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.qa_review_status_enum */
var QaReviewStatusEnum;
(function (QaReviewStatusEnum) {
    QaReviewStatusEnum["Approved"] = "Approved";
    QaReviewStatusEnum["Hold"] = "Hold";
    QaReviewStatusEnum["Rejected"] = "Rejected";
})(QaReviewStatusEnum || (QaReviewStatusEnum = {}));
;
export default QaReviewStatusEnum;
/** Zod schema for qa_review_status_enum */
export const qaReviewStatusEnum = z.nativeEnum(QaReviewStatusEnum);
//# sourceMappingURL=QaReviewStatusEnum.js.map